import * as Html from "../../util/Html.ts";
import * as imageRedim from "../../lib/redim/imageRedim.js";
import {newMultiBarSimple} from "../../util/progressbarmulti.js"
import ApiServer from "../../ApiServer.js";
import * as modal from "../../util/modal.ts";
import * as i18n from "../../i18n.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as amplify from "../../util/amplify.ts";
import * as Medias from "../../server/Medias.js";
import TPL from "../../widget/input-images.mustache";

export {init}
Html.registerWidget('widget/form/input-images',{init:init})

ApiServer["custom.wallpublishphoto"] = async function(form,success){
  var 
    files = 
      $(form)
        .find('[data-widget="widget/form/input-images"]')
        .get(0).customFiles
        .concat([]), //the concat is important to ducplicate the file array, because the reset will clear it
    description = form.description?form.description.value:undefined;
  
  if(files.length===0){
    modal.alert('multiupload.needfile');
    return;
  }

  amplify.publish("resetNewActivity");
  await uploadMultiplePictures(files, description);

}  
export async function uploadMultiplePictures(files, description) {
  var
    wallMessageClientId = new Date().getTime(),
    progressController = newMultiBarSimple(files.length), maxdim = FwDatas.getPermission("photoHD") ? { width: 4096, height: 4096 } : { width: 2048, height: 2048 };

  try{
    for (let i = 0; i < files.length; i++) {
      var file = files[i];
      if (file.size > 1000000) {
        try{
          file = await new Promise((resolve, reject) => {
            imageRedim.downsize(file, maxdim, resolve, reject);
          });
        }catch(e){
          console.log('downsize failed, keep full file',e)
        }
        
      }
      var isLast = i === files.length - 1;
      await ApiServer.wallpublishmultiplepics.setOptions({ progressbar: progressController.subProgress() })({
        wallMessageClientId: wallMessageClientId,
        description: description,
        picture: file,
        finishupload: isLast
      });
    }
  }finally{
    amplify.publish("newActivity");
    progressController.close();
  }
}

function init(node){
  var 
    accept = node.attr("data-fw-accept")||"image/*",
    submitonchange = node.attr("data-submit-on-change")==='true',
    previewContainer = node.find('.fw-dz-add-preview-container>span'),
    form = node.parents('form'),
    files = [];
  
  if(node.attr("data-name")){
    node.append('<input type="hidden" name="'+node.attr("data-name")+'">');
    node.find('input').get(0).customFiles = files;
  }else{
    node.get(0).customFiles = files;
  }
  node.append('<input type="file" multiple style="display:none" accept="'+accept+'">');
  var 
    inputFile = node.find('input[type=file]');
  
  form.on('reset',function(){
    node.find("icon").trigger("click");
  })
  form.on('paste',async function(event){
    if(!await Medias.checkQuota()) return;
    var items = event.originalEvent.clipboardData.items;
    for(var i=0;i<items.length;i++){
      var item = items[i];
      append(item.getAsFile());
    }
  })
  if(form.get(0).clipboardImages){
    form.get(0).clipboardImages.forEach(append);
  }
  node.on("click",async function(e){
    inputFile.trigger('click',e)
  })
  inputFile.on("click",function(e){
    e.stopPropagation();
  })
  inputFile.on("change",async function(e){
    if(!await Medias.checkQuota()) return;
    for(var i=0;i<this.files.length;i++){
      append(this.files[i]);
    }
    this.value="";
    if(submitonchange){
      node.parent('form').trigger('submit');
    }
  })
   
  function append(file){
    if(!file) return;
    if(accept!=='*/*'){
      if(file.type.indexOf("video")===0 && accept.indexOf('video')===-1){
        return;
      }
    }
    files.push(file);
    node.toggleClass("fw-dz-hasfile",files.length!==0);
    
    var preview;
    function remove(){
      var idx = files.indexOf(file);
      if(idx>-1){
        files.splice(idx,1);
      }
      preview.remove();
      node.toggleClass("fw-dz-hasfile",files.length!==0);
    }
    if(previewContainer.length){
      preview = Html.setHtmlAtEnd(previewContainer,TPL,file);
      
      imageRedim.thumbnail(
          file,
          {width:preview.width(),height:preview.height()},
          function(thumb){
            preview.find("img").attr("src",thumb);
          },
          remove
        );
      preview.on("click",function(evt){
        evt.stopPropagation();
      }).find("icon").on("click",function(evt){
        evt.stopPropagation();
        remove();
      })
      
    }
  }

}

